import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  LOCALE_LABELS,
  SUPPORTED_LOCALES,
  changeLocale,
  currentLocale,
  type Locale,
} from "@/i18n";

export function LocaleSwitcher({ id = "locale-switcher" }: { id?: string }) {
  const { t } = useTranslation("common");

  return (
    <span className="inline-flex items-center gap-1.5 text-slate-600">
      <Globe className="h-4 w-4" aria-hidden />
      <label className="sr-only" htmlFor={id}>
        {t("actions.language")}
      </label>
      <select
        id={id}
        className="rounded-md border border-slate-200 px-2 py-1 text-sm text-slate-600"
        value={currentLocale()}
        onChange={(e) => void changeLocale(e.target.value as Locale)}
      >
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {LOCALE_LABELS[locale]}
          </option>
        ))}
      </select>
    </span>
  );
}
